// ADD API URLS BELOW
export const API_URLS = {
    blogListing: '/api/blogs/search',
    caseStudyListing: '/api/case-studies/search',
    downloads: '/api/downloads/',
    marketplaceList: '/api/marketplace/search',
    marketplaceSignup: '/api/marketplace/submit',
    newsletterSubmit: '/api/newsletter/submit',
    premiumResourceSubmit: '/api/premium-resource/submit',
};
